export default {
  titles: {
    listOld: 'Listado de facturas antiguas',
    oldLimit: '* Solo se mostrarán facturas cuya fecha de firma sea mayor de 5 años.',
    list: 'Listado de facturas',
    payList: 'Listado de facturas a pagar',
    financing: 'Listado de facturas para financiación',
    asProviderList: {
      enviadas: 'Listado de facturas enviadas',
      aceptadas: 'Listado de facturas aceptadas',
      rechazadas: 'Listado de facturas rechazadas'
    },
    asPayerList: {
      pendientes: 'Listado de facturas pendientes de tratar',
      tratadas: 'Listado de facturas tratadas'
    }
  },
  searcher: 'Buscador',
  rectified: {
    find: {
      seeRectified: 'Ver rectificada',
      seeRectifying: 'Ver rectificativa'
    },
    errors: {
      rectifyingNotFound: 'Factura rectificativa generada y eliminada por el usuario antes de emitirla.'
    }
  },
  result: {
    true: 'Correcta',
    false: 'Rechazada'
  },
  confirm: {
    acceptProFormPayer: {
      title: 'Aceptar pro formas como proveedor',
      selection: ' No ha seleccionado pro formas. | Ha seleccionado {0} pro forma por un total de {1} para tramitar en el expediente seleccionado. | Ha seleccionado {0} pro formas por un total de {1} para tramitar en el expediente seleccionado.',
      continue: '¿Desea aceptar las pro formas seleccionadas?'
    },
    financeables: {
      title: 'Resumen Financiación',
      selection: ' No ha seleccionado facturas. | Ha seleccionado {0} factura por un total de {1} para tramitar: | Ha seleccionado {0} facturas por un total de {1} para tramitar:',
      selectionBankia: ' No ha seleccionado facturas. | Ha seleccionado {0} factura por un total de {1} para tramitar en el expediente seleccionado: | Ha seleccionado {0} facturas por un total de {1} para tramitar en el expediente seleccionado:',
      continue: '¿Desea continuar con la solicitud de financiación?',
      errorDiscount: 'No puede solicitar Descuento si ya ha solicitado financiación sobre alguna de las facturas seleccionadas',
      errorFactoring: 'No puede solicitar financiación si ya ha solicitado Descuento sobre alguna de las facturas seleccionadas',
      info: 'El acceso al servicio se realiza a través de una ventana emergente o pop-up. Si no puede entrar correctamente, recuerde revisar que estos elementos no los tiene bloqueados su navegador.',
      doubt: 'Para cualquier duda sobre su solicitud pongase en contacto con su financiera'
    },
    acceptBilling: {
      title: 'Listado de facturas seleccionadas para aceptar',
      selection: ' No ha seleccionado facturas. | Ha seleccionado {0} factura por un total de {1} para aceptar. | Ha seleccionado {0} facturas por un total de {1} para aceptar.',
      continue: '¿Desea aceptar las facturas seleccionadas?'
    },
    rejectProFormPayer: {
      title: 'Listado de pro fromas seleccionadas para rechazar',
      selection: ' No ha seleccionado pro formas. | Ha seleccionado {0} pro forma por un total de {1} para rechazar. | Ha seleccionado {0} pro formas por un total de {1} para rechazar.',
      continue: '¿Desea rechazar las pro formas seleccionadas?',
      text: 'Por favor, indique el motivo del rechazo'
    },
    rejectBilling: {
      title: 'Listado de facturas seleccionadas para rechazar',
      selection: ' No ha seleccionado facturas. | Ha seleccionado {0} factura por un total de {1} para rechazar. | Ha seleccionado {0} facturas por un total de {1} para rechazar.',
      continue: '¿Desea rechazar las facturas seleccionadas?',
      text: 'Por favor, indique el motivo del rechazo'
    },
    unrejectBilling: {
      title: 'Listado de facturas seleccionadas para ser des-rechazadas',
      selection: ' No ha seleccionado facturas. | Ha seleccionado {0} factura por un total de {1} para des-rechazar. | Ha seleccionado {0} facturas por un total de {1} para des-rechazar.',
      continue: '¿Desea des-rechazar las facturas seleccionadas?',
      text: 'Por favor, indique el motivo del des-rechazo'
    },
    acceptSelfBilling: {
      title: 'Listado de facturas seleccionadas para ser aceptadas',
      selection: ' No ha seleccionado facturas. | Ha seleccionado {0} factura por un total de {1} para aceptar. | Ha seleccionado {0} facturas por un total de {1} para aceptar.',
      continue: '¿Desea aceptar facturas de las facturas seleccionadas?'
    },
    rejectSelfBilling: {
      title: 'Listado de facturas seleccionadas para ser rechazadas',
      selection: ' No ha seleccionado facturas. | Ha seleccionado {0} factura por un total de {1} para rechazar. | Ha seleccionado {0} facturas por un total de {1} para rechazar.',
      continue: '¿Desea rechazar las facturas seleccionadas?',
      text: 'Por favor, indique el motivo del rechazo'
    },
    cancelInvoice: {
      title: 'Listado de facturas seleccionadas para solicitar su anulación',
      selection: ' No han seleccionado facturas. | Ha seleccionado {0} factura por un total de {1} para solicitar anulación. | Ha seleccionado {0} facturas por un total de {1} para solicitar anulación.',
      continue: '¿Desea solicitar la anulación de las facturas seleccionadas?',
      text: 'Indique el motivo de la anulación'
    },
    acceptCancel: {
      title: 'Listado de facturas seleccionadas para aceptar su anulación',
      selection: ' No han seleccionado facturas. | Ha seleccionado {0} factura por un total de {1} para aceptar su anulación. | Ha seleccionado {0} facturas por un total de {1} para aceptar su anulación.',
      continue: '¿Desea aceptar la anulación de las facturas seleccionadas?',
      text: 'Indique el motivo de aceptación de la anulación',
      error: 'Para aceptar la anulación de una factura, previamente debe solicitarse su anulación por parte del proveedor'
    },
    rejectCancel: {
      title: 'Listado de facturas seleccionadas para rechazar su anulación',
      selection: ' No han seleccionado facturas. | Ha seleccionado {0} factura por un total de {1} para rechazar su anulación. | Ha seleccionado {0} facturas por un total de {1} para rechazar su anulación.',
      continue: '¿Desea rechazar la anulación de las facturas seleccionadas?',
      text: 'Indique el motivo de rechazo de la anulación',
      error: 'Para rechazar la anulación de una factura, previamente debe solicitarse su anulación por parte del proveedor'
    },
    issue: {
      title: 'Listado de facturas seleccionadas para emitir',
      selection: ' No ha seleccionado facturas. | Ha seleccionado {0} factura por un total de {1} para emitir. | Ha seleccionado {0} facturas por un total de {1} para emitir.',
      info: '',
      continue: '¿Desea emitir las facturas seleccionadas?'
    },
    issueProFromPayer: {
      title: 'Listado de pro formas seleccionadas para emitir',
      selection: ' No ha seleccionado pro formas. | Ha seleccionado {0} pro forma por un total de {1} para emitir. | Ha seleccionado {0} pro formas por un total de {1} para emitir.',
      continue: '¿Desea emitir las pro formas seleccionadas?'
    },
    issueSelf: {
      title: 'Listado de autofacturas seleccionadas para emitir',
      selection: ' No ha seleccionado autofacturas. | Ha seleccionado {0} autofactura por un total de {1} para emitir. | Ha seleccionado {0} autofacturas por un total de {1} para emitir.',
      continue: '¿Desea emitir las autofacturas seleccionadas?'
    },
    issueproforma: {
      title: 'Listado de facturas seleccionadas para enviar pro formas',
      selection: ' No ha seleccionado facturas. | Ha seleccionado {0} factura por un total de {1} para enviar pro forma. | Ha seleccionado {0} facturas por un total de {1} para enviar pro formas.',
      continue: '¿Desea enviar pro formas de las facturas seleccionadas?'
    },
    issueproformaSelf: {
      title: 'Listado de autofacturas seleccionadas para enviar pro formas',
      selection: ' No ha seleccionado autofacturas. | Ha seleccionado {0} autofactura por un total de {1} para enviar pro forma. | Ha seleccionado {0} autofacturas por un total de {1} para enviar pro formas.',
      continue: '¿Desea enviar pro formas de las autofacturas seleccionadas?'
    },
    send: {
      title: 'Listado de facturas seleccionadas para enviar',
      selection: ' No ha seleccionado facturas. | Ha seleccionado {0} factura por un total de {1} para enviar. | Ha seleccionado {0} facturas por un total de {1} para enviar.',
      info: {
        contractReference: 'La factura de terceros {1} no incluye la "Referencia de Contrato" (ej: T123456) de carácter generalmente obligatorio para Bankia. En factras introducidas manualmente este dato se ha de recoger en la sección "Datos del gestor". | Las facturas de terceros {1} no incluyen la "Referencia de Contrato" (ej: T123456) de carácter generalmente obligatorio para Bankia. En facturas introducidas manualmente este dato se ha de recoger en la sección "Datos del gestor".',
        fixField: 'Si lo desea aún puede cancelar el proceso de emisión/envío para introducir en la factura dicho dato.'
      },
      continue: '¿Desea enviar las facturas seleccionadas?'
    },
    remove: {
      title: 'Listado de facturas seleccionadas para eliminar',
      selection: ' No ha seleccionado facturas. | Ha seleccionado {0} factura por un total de {1} para eliminar. | Ha seleccionado {0} facturas por un total de {1} para eliminar.',
      continue: '¿Desea eliminar las facturas seleccionadas?'
    },
    deleteProFormProvider: {
      title: 'Listado de pro formas seleccionadas para eliminar',
      selection: ' No ha seleccionado pro formas. | Ha seleccionado {0} pro forma por un total de {1} para eliminar. | Ha seleccionado {0} pro formas por un total de {1} para eliminar.',
      continue: '¿Desea eliminar las pro formas seleccionadas?'
    },
    removeSelf: {
      title: 'Listado de autofacturas seleccionadas para eliminar',
      selection: ' No ha seleccionado autofacturas. | Ha seleccionado {0} autofactura por un total de {1} para eliminar. | Ha seleccionado {0} autofacturas por un total de {1} para eliminar.',
      continue: '¿Desea eliminar las autofacturas seleccionadas?'
    }
  },
  headers: {
    created: 'F. creación',
    issue: 'F. emisión',
    id: 'Serie - Número',
    provider: 'Proveedor',
    client: 'Cliente',
    status: 'Estado',
    type: 'Tipo',
    serie: 'Serie',
    number: 'Número',
    amount: 'Importe',
    result: 'Resultado',
    comments: 'Comentarios',
    invoiceId: 'Identificador fiscal',
    format: 'Formato'
  },
  csv: {
    invoiceId: 'Identificador fiscal',
    createDate: 'Fecha creación',
    incomeDate: 'Fecha devengo',
    issueDate: 'Fecha emisión',
    provider: {
      name: 'Nombre proveedor',
      document: 'NIF proveedor'
    },
    agent: {
      name: 'Nombre gestor',
      document: 'NIF gestor'
    },
    client: {
      name: 'Nombre cliente',
      document: 'NIF cliente'
    },
    status: 'Estado',
    type: 'Tipo',
    taxableAmount: 'Base imponible',
    taxes: 'Total impuestos',
    amount: 'Importe total'
  },
  filter: {
    byCreated: 'Fecha de creación',
    byIssued: 'Fecha de emisión',
    from: 'Desde',
    to: 'Hasta',
    byId: 'Serie y número',
    bySerie: 'Serie',
    byNumber: 'Número',
    byStatus: 'Estado',
    byDocument: 'Documento',
    byProviderDocument: 'NIF/CIF/NIE Proveedor',
    byClientDocument: 'NIF/CIF/NIE Cliente',
    byAmount: 'Importe (€)',
    delegations: 'Delegaciones',
    days: 'Días',
    months: 'Meses',
    years: 'Años',
    other: 'Otros'
  },
  download: {
    asCSV: 'Descargar CSV',
    asPDF: 'Descargar en PDF'
  },
  helps: {
    type: 'En el tipo de factura (A) indica factura de Abono y (R) rectificativa.'
  },
  actions: {
    acceptSelfBilling: 'Aceptar autofacturas',
    rejectSelfBilling: 'Rechazar autofacturas',
    acceptBilling: 'Aceptar facturas',
    rejectBilling: 'Rechazar facturas',
    unrejectBilling: 'Des-rechazar facturas',
    financing: 'Solicitar financiación',
    acceptFinancing: 'Aceptar condiciones',
    cancelInvoice: 'Anular facturas'
  },
  types: {
    1: 'Factura',
    4: 'Autofactura'
  },
  subtypes: {
    payment: ' (A)',
    rectify: ' (R)'
  },
  financing: {
    nif: 'N.I.F.',
    name: 'Nombre',
    surname: 'Apellidos',
    phone: 'Teléfono móvil',
    email: 'Email de contacto',
    iban: 'IBAN',
    error: 'La operación no se ejecutó correctamente, por favor vuelva a intentarlo de nuevo.',
    popup: 'Por favor, si desea continuar con la operación debe desactivar el bloqueo de ventanas emergentes.',
    errorMessages: {
      notExpedients: 'Para solicitar el anticipo de facturas debe tener contratado el servicio de financiación',
      notGeneralModule: 'Para solicitar el anticipo de facturas a través de financiación debe tener contratado el módulo general de la Oficina Internet de Empresas con envío de ficheros en Formato libre.',
      notExpedientsNorGeneralModule: 'Para solicitar el anticipo de facturas debe tener contratado el módulo general de la Oficina Internet de Empresas con envío de ficheros en Formato libre y el servicio de financiación.'
    },
    popFinanceables: {
      wait: 'Espere un momento, por favor.',
      access: 'Se está accediendo al servicio de financiación...'
    },
    signValidation: 'Introduzca su clave de firma para continuar con la operativa.',
    simulation: {
      simulate: 'Simular Financiación',
      loading: 'Se está calculando la financiación. Por favor, espere...',
      result: 'Resultado de la simulación de financiación:',
      final: 'Líquido Final:',
      retention: 'Retención de Importe:',
      fee: 'Interés y Comisión:',
      question: '¿Desea realizar una simulación de la financiación?'
    },
    tooltip: {
      nif: 'DNI de administrador o representante de la empresa <br> Para autónomos: NIF',
      phone: 'Obligatorio para enviar el contrato por SMS',
      iban: 'Cuenta IBAN que aparecerá en el contrato'
    }
  },
  issue: {
    errors: {
      tryAgain: 'Su factura ha sido guardada con éxito, pero ha ocurrido un problema durante la emisión. Intente emitirla de nuevo desde el listado o edítela de nuevo.',
      maxInvoicesIssued: 'No se permite emitir más de {0} facturas con una cuenta gratuita | Se han emitido ya {0} facturas así que solo se pueden emitir {1} facturas más con una cuenta gratuita. | Has llegado al límite de facturas emitidas al año. Pásate a la cuenta PRO y disfruta de todas las ventajas que ofrece este servicio.',
      freeAccount: 'Cuenta Gratuita',
      maxInvoicesIssuedModal: 'Has llegado al límite de facturas emitidas al año. Pásate a la cuenta PRO y disfruta de todas las ventajas que ofrece este servicio.'
    }
  },
  save: {
    errors: {
      maxAmount: 'El importe total de la factura supera el máximo permitido (99.999.999,00 EUR)',
      maxSize: 'Se ha superado el limite (8192 Kbytes), para los ficheros adjuntos de una factura.',
      dir3Info: 'Al seleccionar un contacto con Dir3 es obligatorio rellenar los tipos: Oficina Contable, Órgano gestor y Unidad tramitadora'
    }
  },
  validations: {
    drafts: {
      noContractReference: 'La factura no incluye la \'Referencia de Contrato\' (ej: T123456) de carácter generalmente obligatorio para Bankia. En facturas introducidas manualmente este dato se ha de recoger en la sección "Datos del Proveedor" (Datos Generales). Si lo desea, aún puede cancelar el proceso de emisión / envío para introducir en la factura dicho envío'
    },
    autodrafts: {
      noContractReference: 'La autofactura no incluye la \'Referencia de Contrato\' (ej: T123456) de carácter generalmente obligatorio para Bankia. En facturas introducidas manualmente este dato se ha de recoger en la sección "Datos del Proveedor" (Datos Generales). Si lo desea, aún puede cancelar el proceso de emisión / envío para introducir en la factura dicho envío'
    },
    thirdPartyDrafts: {
      noContractReference: 'La factura de terceros no incluye la \'Referencia de Contrato\' (ej: T123456) de carácter generalmente obligatorio para Bankia. En facturas introducidas manualmente este dato se ha de recoger en la sección "Datos del Gestor" (Datos Generales). Si lo desea, aún puede cancelar el proceso de emisión / envío para introducir en la factura dicho envío'
    }
  }
}
